/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mesafeli_S13_Link_IadeInputs */

const tr_mesafeli_s13_link_iade = /** @type {(inputs: Mesafeli_S13_Link_IadeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Abonelik İptal ve Fesih Politikası`)
};

const en_mesafeli_s13_link_iade = /** @type {(inputs: Mesafeli_S13_Link_IadeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Subscription Cancellation and Termination Policy`)
};

const de_mesafeli_s13_link_iade = /** @type {(inputs: Mesafeli_S13_Link_IadeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Richtlinie zu Kündigung und Beendigung des Abonnements`)
};

const ru_mesafeli_s13_link_iade = /** @type {(inputs: Mesafeli_S13_Link_IadeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Политика отмены и расторжения подписки`)
};

/**
* | output |
* | --- |
* | "Subscription Cancellation and Termination Policy" |
*
* @param {Mesafeli_S13_Link_IadeInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const mesafeli_s13_link_iade = /** @type {((inputs?: Mesafeli_S13_Link_IadeInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mesafeli_S13_Link_IadeInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_mesafeli_s13_link_iade(inputs)
	if (locale === "de") return de_mesafeli_s13_link_iade(inputs)
	if (locale === "ru") return ru_mesafeli_s13_link_iade(inputs)
	return tr_mesafeli_s13_link_iade(inputs)
});